import { useState } from "react";
import './style.css';

export default function ReportDetailsContainer({ startDate, endDate, participants, password, evaluationUrl }) {
    const [copied, setCopied] = useState(false);

    const handleCopyUrl = () => {
        navigator.clipboard.writeText(evaluationUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // Hide after 1.5 seconds
    };

    return (
        <div className="action-tile">
            <div className="report-details-container">
                <div className="action-title-container">
                    <h3>Report Info</h3>
                </div>
                <div className="report-details-text-container">
                    <h2 className="report-details-title">Start Date</h2>
                    <p className="report-details-text">{new Date(startDate).toLocaleDateString()}</p>
                </div>
                <div className="report-details-divider-container">
                    <div className="report-details-divider"></div>
                </div>
                <div className="report-details-text-container">
                    <h2 className="report-details-title">End Date</h2>
                    <p className="report-details-text">{new Date(endDate).toLocaleDateString()}</p>
                </div>
                <div className="report-details-divider-container">
                    <div className="report-details-divider"></div>
                </div>
                <div className="report-details-text-container">
                    <h2 className="report-details-title">Participants</h2>
                    <p className="report-details-text">{participants}</p>
                </div>
                <div className="report-details-divider-container">
                    <div className="report-details-divider"></div>
                </div>
                <div className="report-details-text-container">
                    <h2 className="report-details-title">Access Code</h2>
                    <p className="report-details-text">{password}</p>
                </div>
                <div className="report-details-divider-container">
                    <div className="report-details-divider"></div>
                </div>
                <br></br>
                <div className="report-details-text-container">
                    <label className="evaluation-label">Copy URL</label>
                    <input
                        type="text"
                        readOnly
                        value={evaluationUrl}
                        className="copy-input"
                        onClick={handleCopyUrl}
                    />
                    {copied && (
                        <div className="clipboard-popup">
                            URL copied to Clipboard
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
